import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ProductsFilter from "./ProductsFilter";
import ProductScheduleList from "./ProductScheduleList";
import ProductBranchesReport from "./ProductBranchesReport";
import SchedulesActionBar from "./SchedulesActionBar";
import Button from "../Button";
import ProductsActionBar from "./ProductsActionBar";

class ProductsReport extends React.Component {
  state = {
    viewMode: "schedules",
    products: [],
    selectedProductIds: [],
    selectedSchedules: [],
    showList: false,
    version: 1
  };

  setProducts = (products, viewMode) => {
    this.setState({ showList: true, products, viewMode }, () => {
      this.state.viewMode == "schedules" && this.productList.addProducts(products);
    });
  };

  reloadAndReset = () => {
    this.productsFilter.findProducts();
    this.setState(state => ({
      version: state.version + 1,
      selectedProducts: [],
      selectedSchedules: []
    }));
  };

  renderProductSchedules() {
    const { company_id } = this.props;
    const { selectedProductIds, selectedSchedules, showList, version } = this.state;
    if (!showList) return null;
    return (
      <Fragment>
        <SchedulesActionBar
          company_id={company_id}
          schedules={selectedSchedules}
          productIds={selectedProductIds}
          reloadProducts={this.reloadAndReset}
        />
        <ProductScheduleList
          key={version}
          ref={ref => (this.productList = ref)}
          company_id={company_id}
          updateSelectedProducts={selectedProductIds => this.setState({ selectedProductIds })}
          updateSelectedSchedules={selectedSchedules => this.setState({ selectedSchedules })}
        />
      </Fragment>
    );
  }

  renderProductBranches() {
    const { company_id } = this.props;
    const { showList, version, products } = this.state;
    if (!showList) return null;
    return (
      <ProductBranchesReport
        reloadProducts={this.reloadAndReset}
        products={products}
        company_id={company_id}
      />
    );
  }

  render() {
    const { company_id } = this.props;
    const { viewMode } = this.state;
    return (
      <div>
        <ProductsFilter
          ref={ref => (this.productsFilter = ref)}
          company_id={company_id}
          setProducts={this.setProducts}
          setMode={this.setMode}
        />

        {viewMode == "schedules" && this.renderProductSchedules()}
        {viewMode == "branches" && this.renderProductBranches()}
      </div>
    );
  }
}

export default ProductsReport;

ProductsReport.propTypes = {
  company_id: PropTypes.number
};
